"use client";

import { motion } from "motion/react";

type CircleProps = {
  animationCallback?: () => void;
  callbackDelay?: number;
  size?: number;
};

export function Check({
  animationCallback,
  callbackDelay = 0,
  size = 50,
}: CircleProps) {
  return (
    <div className="animation-check-circle text-green-600">
      <motion.svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        fill="currentColor"
        viewBox="0 0 256 256"
        animate={{ opacity: 0, y: 10 }}
        initial={{ opacity: 1 }}
        onAnimationComplete={() => {
          if (animationCallback) {
            setTimeout(animationCallback, callbackDelay);
          }
        }}
        transition={{
          bounce: 0,
          delay: 1.25,
          duration: 0.2,
          ease: "linear",
        }}
      >
        <motion.path
          fill="none"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="12"
          d="M172 104L113.3 160 84 132"
          animate={{ pathLength: 1, pathOffset: 0 }}
          initial={{ pathLength: 0, pathOffset: 1 }}
          transition={{
            bounce: 0,
            duration: 0.5,
            ease: "linear",
          }}
        />
        <circle
          cx="128"
          cy="128"
          r="96"
          fill="none"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="12"
        />
      </motion.svg>
    </div>
  );
}
